//
// BaseReport.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../TransportModel";
import "../media/ReportMetadata";
import "./Connection";
import "./ReportCategoryType";

var BaseReport = createModule("transport::BaseReport", ["commons::PropertyOwner","commons::BaseModel","transport::TransportModel"], EventDispatcher, [
    {
        UNSUBSCRIBED: 60051,
        CONNECTION_UPDATED: 60052,
        PROMOTION: 60049,
        SUBSCRIBED: 60050,
    },
    {
        isRecycled: 2,
        meta: 1,
        reportCategory: 4,
        connection: 1,
        promoted: 7,
    },
    {
        uuid: 7,
    },
    ,
    {
        getUserName: [7,1],
    },
    {
        _create: [4],
    },
    ,
]);
export default BaseReport;
